import { getHTMLWithLinkedTags } from "./getHTMLWithLinkedTags";
import { linkToOwnProfile } from "./linkToOwnProfile";

export const addLinks = (content: string, id: string) => linkToOwnProfile(getHTMLWithLinkedTags(content), id)

export const extractHashtags = (input: string): string[] => {
  const regex = /#(\w+)/g
  const matches = input.match(regex)

  if (matches) {
    return matches.map(match => match.substring(1))
  }

  return []
}
